(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('OruloService', OruloService);

    OruloService.$inject = ['OruloFactory'];

    function OruloService(OruloFactory) {
        var service = {
            save: save,
            disconnect: disconnect,
            getByHubId: getByHubId,
            getById: getById,
            reconnect: reconnect,
            reprocess: reprocess
        };

        return service;

        function save(oruloConfig) {
            return OruloFactory.save(oruloConfig).$promise;
        }

        function disconnect() {
            return OruloFactory.delete().$promise;
        }

        function getByHubId() {
            return OruloFactory.getByHubId().$promise;
        }

        function getById(id) {
            return OruloFactory.getById({ id: id }).$promise;
        }

        function reconnect(oruloConfig) {
            return OruloFactory.reconnect(oruloConfig).$promise;
        }

        function reprocess(oruloConfig) {
            return OruloFactory.reprocess(oruloConfig).$promise;
        }
    }
})();
